/* global Fingerprint, FingerprintService, $ */

/**
 * Fingerprint Factory
 *
 * Returns
 *
 * @param apiUrl
 * @param scope
 * @returns {Fingerprint}
 * @constructor
 */
window.FingerprintFactory = function (apiUrl, scope) {
  var ServiceClient = new FingerprintService(apiUrl);
  var UAParser = $.shopgate.uaparser;

  return new Fingerprint(scope, ServiceClient, UAParser);
};



// WEBPACK FOOTER //
// ./Library/1.0/common/Fingerprint/FingerprintFactory.js